"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
const worker_1 = __importDefault(require("./worker"));
class WebWorkerController {
    constructor(apiUrl) {
        this.startCbs = [];
        this.stopCbs = [];
        this.onResponseCb = () => { };
        this.onCloseCb = () => { };
        this.onWebsocketMessage = (event) => {
            const response = event.data;
            switch (response.type) {
                case types_1.WebsocketResponseType.Started:
                    this.startCbs.forEach(cb => {
                        try {
                            cb(undefined, response.audio_context);
                        }
                        catch (e) {
                            console.error('[SpeechlyClient] Error while invoking "onStart" callback:', e);
                        }
                    });
                    this.startCbs.length = 0;
                    break;
                case types_1.WebsocketResponseType.Stopped:
                    this.stopCbs.forEach(cb => {
                        try {
                            cb(undefined, response.audio_context);
                        }
                        catch (e) {
                            console.error('[SpeechlyClient] Error while invoking "onStop" callback:', e);
                        }
                    });
                    this.stopCbs.length = 0;
                    break;
                default:
                    this.onResponseCb(response);
            }
        };
        this.apiUrl = apiUrl;
    }
    onResponse(cb) {
        this.onResponseCb = cb;
    }
    onClose(cb) {
        this.onCloseCb = cb;
    }
    initialize(token, sourceSampleRate, targetSampleRate) {
        return __awaiter(this, void 0, void 0, function* () {
            this.authToken = token;
            if (this.worker !== undefined) {
                throw Error('Cannot initialize an already initialized worker');
            }
            const blob = new Blob([worker_1.default], { type: 'text/javascript' });
            const blobURL = window.URL.createObjectURL(blob);
            this.worker = new Worker(blobURL);
            this.worker.postMessage({
                type: 'INIT',
                apiUrl: this.apiUrl,
                authToken: this.authToken,
                sourceSampleRate,
                targetSampleRate,
            });
            if (this.worker != null) {
                this.worker.addEventListener('message', this.onWebsocketMessage);
            }
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (this.worker != null) {
                    this.worker.postMessage({
                        type: 'CLOSE',
                        code: 1000,
                        message: 'Client has ended the session',
                    });
                    resolve();
                }
            });
        });
    }
    startContext() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                this.startCbs.push((err, id) => {
                    if (err !== undefined) {
                        reject(err);
                    }
                    else {
                        resolve(id);
                    }
                });
                (_a = this.worker) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'START_CONTEXT' });
            });
        });
    }
    stopContext() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var _a;
                this.stopCbs.push((err, id) => {
                    if (err !== undefined) {
                        reject(err);
                    }
                    else {
                        resolve(id);
                    }
                });
                (_a = this.worker) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'STOP_CONTEXT' });
            });
        });
    }
    postMessage(message) {
        var _a;
        (_a = this.worker) === null || _a === void 0 ? void 0 : _a.postMessage(message);
    }
    sendAudio(audioChunk) {
        var _a;
        (_a = this.worker) === null || _a === void 0 ? void 0 : _a.postMessage({ type: 'AUDIO', payload: audioChunk });
    }
}
exports.WebWorkerController = WebWorkerController;
//# sourceMappingURL=webWorkerController.js.map